var map = {
	"./audio-placeholder": 868,
	"./audio-placeholder.png": 868,
	"./avatar-missing": 457,
	"./avatar-missing.png": 457,
	"./avatar-missing.svg": 962,
	"./header-missing": 838,
	"./header-missing.png": 838,
	"./soapbox-logo": 839,
	"./soapbox-logo-white": 840,
	"./soapbox-logo-white.svg": 840,
	"./soapbox-logo.svg": 839,
	"./video-placeholder": 869,
	"./video-placeholder.png": 869,
	"./void": 870,
	"./void.png": 870,
	"./web-push/web-push-icon_expand": 884,
	"./web-push/web-push-icon_expand.png": 884,
	"./web-push/web-push-icon_favourite": 885,
	"./web-push/web-push-icon_favourite.png": 885,
	"./web-push/web-push-icon_reblog": 886,
	"./web-push/web-push-icon_reblog.png": 886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 961;